import UserModel from '@/models/User';

const GET_TRAVELER_LIST = 'GET_TRAVELER_LIST';
const GET_SELECTED_TRAVELER_DETAIL = 'GET_SELECTED_TRAVELER_DETAIL';
const CLEAR_SELECTED_TRAVELER_LIST = 'CLEAR_SELECTED_TRAVELER_LIST';
const UPDATE_SELECTED_TRAVELER = 'UPDATE_SELECTED_TRAVELER';
const DELETE_SELECTED_TRAVELER = 'DELETE_SELECTED_TRAVELER';

/**
 * 获取出行人列表
 */
async function getTravelerList() {
  const payload = await new UserModel().travelerList();
  return {
    type: GET_TRAVELER_LIST,
    payload
  }
}

/**
 * 获取选中的出行人详情
 */
async function getSelectedTravelerDetail(id) {
  const payload = await new UserModel().travelerDetail(id);
  return {
    type: GET_SELECTED_TRAVELER_DETAIL,
    payload
  }
}

/**
 * 清除选中的出行人列表信息
 */
async function clearSelectedTravelerList() {
  return {
    type: CLEAR_SELECTED_TRAVELER_LIST,
  }
}

/**
 * 更新选中的出行人信息
 * @param {Array} travelerList 需要更新的出行人信息
 */
async function updateSelectedTraveler(travelerList) {
  return {
    type: UPDATE_SELECTED_TRAVELER,
    payload: travelerList
  }
}

/**
 * 删除选中的出行人信息
 * @param {Array} ids 需要删除的出行人id列表
 */
async function deleteSelectedTraveler(ids) {
  return {
    type: DELETE_SELECTED_TRAVELER,
    payload: ids
  }
}

const ACTION_TYPES = {
  GET_TRAVELER_LIST,
  GET_SELECTED_TRAVELER_DETAIL,
  CLEAR_SELECTED_TRAVELER_LIST,
  UPDATE_SELECTED_TRAVELER,
  DELETE_SELECTED_TRAVELER,
};

const ACTION = {
  getTravelerList,
  getSelectedTravelerDetail,
  clearSelectedTravelerList,
  updateSelectedTraveler,
  deleteSelectedTraveler,
};

const TravelerList = {
  ACTION_TYPES,
  ACTION
}

export default TravelerList;